import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';

import {Authorization} from '@appComponents/Authorization';
import {IconWithTooltip} from '@appComponents/IconCollection';
import {ARGOS_JOB} from '@constants/resources';
import {SECURITY_PRIVILEGES_DELETE} from '@constants/variables';
import {getLink} from '@appComponents/Link';
import {ArgosJobStartStopButtons} from '@modules/events/components/ArgosJobStartStopButtons';
import {buildArgosDashboardJobUrl, buildArgosDashboardJobsFilterUrl} from '@modules/events/utils/argosDashboardUrl';

const authorizationDelete = {
    [ARGOS_JOB]: SECURITY_PRIVILEGES_DELETE,
};

export const ArgosTitle = ({job, eventId, onDelete, onStartStopSuccess}) => {
    const history = useHistory();
    const jobId = job?.id;
    const jobUuid = job?.job_uuid;
    const description = job?.description;

    function handleDelete(e) {
        e.stopPropagation();

        if (onDelete) onDelete();
    }

    return (
        <div className='argos-title'>
            <span className='argos-title__main'>
                {description
                    ? `Argos job ${jobId} - ${description}`
                    : `Argos job ${jobId}`}
            </span>
            <span className='argos-title__uuid'>
                {jobUuid ? `Job UUID: ${jobUuid}` : null}
                {jobUuid && (
                    <span className='argos-title__uuid-link'>
                        <IconWithTooltip
                            name='external alternate'
                            tooltip='Open the Argos job in the Argos dashboard'
                            popupProps={{position: 'top center'}}
                            iconProps={{
                                onClick: (e) => {
                                    e.stopPropagation();
                                    window.open(buildArgosDashboardJobUrl(jobUuid), '_blank');
                                },
                            }}
                        />
                    </span>
                )}
            </span>
            <span className='argos-title__right'>
                {job && (
                    <ArgosJobStartStopButtons
                        job={job}
                        onSuccess={onStartStopSuccess}
                    />
                )}
                <IconWithTooltip
                    name='setting'
                    tooltip='Configure the Argos job'
                    popupProps={{position: 'top center'}}
                    resource={ARGOS_JOB}
                    onClick={() => history.push(getLink('events.argosJobs.edit', {id: eventId, argosJobId: jobId}))}
                />
                {jobUuid && (
                    <IconWithTooltip
                        name='external alternate'
                        tooltip='Show the Argos job in the Argos dashboard'
                        popupProps={{position: 'top left'}}
                        onClick={() => window.open(buildArgosDashboardJobsFilterUrl(jobUuid), '_blank')}
                    />
                )}
                <Authorization authorization={authorizationDelete}>
                    <IconWithTooltip
                        name='trash'
                        tooltip='Delete the Argos job'
                        popupProps={{position: 'top left'}}
                        onClick={handleDelete}
                    />
                </Authorization>
            </span>
        </div>
    );
};


ArgosTitle.propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    job: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        description: PropTypes.string,
        job_uuid: PropTypes.string,
        start_datetime: PropTypes.string,
        end_datetime: PropTypes.string,
        state: PropTypes.string,
        live_job: PropTypes.object,
    }).isRequired,
    onDelete: PropTypes.func,
    onStartStopSuccess: PropTypes.func,
};
